const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const normalizeLabel = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("fr")
    .trim();

export const getMaterialMissingQuantity = (material = {}) => {
  const explicitMissing = toFiniteNumber(material.lot_missing_quantity);
  if (explicitMissing !== null && explicitMissing > 0) {
    return explicitMissing;
  }

  const required = toFiniteNumber(material.required_quantity);
  const available = toFiniteNumber(
    material.available ?? material.current_stock
  );

  if (required === null || available === null) {
    return 0;
  }

  return Math.max(required - available, 0);
};

export const getLotWatchProductNames = (guardrails) => {
  const items = guardrails?.user_guidance?.lot_watch_items;
  if (!Array.isArray(items)) {
    return [];
  }

  return items.reduce((names, item) => {
    const productName = String(item?.title || "").split(":")[0].trim();
    if (
      productName &&
      !names.some((existingName) =>
        normalizeLabel(existingName) === normalizeLabel(productName)
      )
    ) {
      names.push(productName);
    }
    return names;
  }, []);
};

export const getMaterialAttentionState = (material, watchedNames = []) => {
  if (!material?.is_sufficient || getMaterialMissingQuantity(material) > 0) {
    return "shortage";
  }

  const materialName = normalizeLabel(material?.product_name);
  if (
    materialName &&
    watchedNames.some((name) => normalizeLabel(name) === materialName)
  ) {
    return "watch";
  }

  return "available";
};

export const sortMaterialsForDecision = (materials = [], watchedNames = []) => {
  return (Array.isArray(materials) ? materials : [])
    .map((material, index) => ({ material, index }))
    .sort((left, right) => {
      const leftRank =
        getMaterialAttentionState(left.material, watchedNames) === "shortage"
          ? 0
          : 1;
      const rightRank =
        getMaterialAttentionState(right.material, watchedNames) === "shortage"
          ? 0
          : 1;
      const stateDifference = leftRank - rightRank;

      return stateDifference || left.index - right.index;
    })
    .map(({ material }) => material);
};

export const getLaunchDisabledReason = ({
  hasResults,
  allAvailable,
  guardrailStatus,
  hasWarehouse,
  producing,
  canLaunch,
  contextLabel = "production",
}) => {
  if (!hasResults) {
    return "Calculez d'abord les besoins.";
  }
  if (!hasWarehouse) {
    return "Sélectionnez un établissement avant de lancer.";
  }
  if (!canLaunch) {
    return `Vous n'avez pas la permission de lancer cette ${contextLabel}.`;
  }
  if (producing) {
    return "Lancement en cours…";
  }
  if (!allAvailable) {
    return "Disponible après résolution du stock manquant.";
  }
  if (guardrailStatus === "blocked") {
    return "Disponible après résolution des contrôles bloquants.";
  }

  return null;
};
